export default "__VITE_ASSET__CKg0yhic__"